export default __webpack_public_path__ + "static/Newton-0f304ddc6ab805064fd436cd7b1fc5e4.jpg";